import React,{useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import {
  ActionCard,
  ActionCardFlexContainer,
  AuthFlexContainer,
  ContentFlexContainer,
} from '../../components/ContentContainers.styled';
import SignupForm from './Signup.form';
import styled from 'styled-components';
import { stripHtmlString } from '../../../../shared/helpers/General';
const InstructionDiv = styled.div`
    display: flex;
    width: 90%;
    min-height: 107px;
    align-items: center;
    gap: 22px;
    flex-shrink: 0;
    border-radius: 5px;
    background: var(--info-bkgd, #DEECFF);
    margin:0px auto 10px  auto;
`;

const LeftDiv = styled.div`
    width: 20px;
    flex-shrink: 0;
    align-self: stretch;
    border-radius: 5px 0px 0px 5px;
    background: var(--info-text, #255A94);
`;

const IconDiv = styled.div`

`;

const DescriptionDiv = styled.div`
padding-right:10px;
padding-top:10px;
word-break: break-word;
`;


export default function SignupPageContent() {
  const auth = useSelector(state => state.auth);
  const [showInstruction, setShowInstruction] = useState(false);
  const [instruction, setInstruction] = useState("");

  
  useEffect(() => {
    if (auth && auth.organization) {
      let updatedIntro = null;
      if(auth.organization?.info?.sign_in_instruction && stripHtmlString(auth.organization?.info?.sign_in_instruction).trim().length > 0) {
        updatedIntro = !!auth.organization?.info?.sign_in_instruction ? auth.organization?.info?.sign_in_instruction.replace(/<p><\/p>/g, '<br />') : '';
      }
      setShowInstruction(auth.organization?.info?.show_sign_in_instruction);
      setInstruction(updatedIntro);
    }
  }, [auth]);

  return (
    <AuthFlexContainer>
      { showInstruction && instruction &&
          <InstructionDiv>
            <LeftDiv></LeftDiv>
            <IconDiv>
              <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45" fill="none">
                <path d="M22.5 4.92188C12.8074 4.92188 4.92188 12.8074 4.92188 22.5C4.92188 32.1926 12.8074 40.0781 22.5 40.0781C32.1926 40.0781 40.0781 32.1926 40.0781 22.5C40.0781 12.8074 32.1926 4.92188 22.5 4.92188ZM22.5 12.1289C22.952 12.1289 23.3938 12.2629 23.7696 12.514C24.1454 12.7651 24.4383 13.122 24.6112 13.5396C24.7842 13.9571 24.8294 14.4166 24.7412 14.8599C24.6531 15.3032 24.4354 15.7103 24.1158 16.0299C23.7963 16.3495 23.3891 16.5671 22.9458 16.6553C22.5025 16.7435 22.0431 16.6982 21.6255 16.5253C21.208 16.3523 20.8511 16.0594 20.6 15.6836C20.3489 15.3078 20.2148 14.866 20.2148 14.4141C20.2148 13.808 20.4556 13.2268 20.8842 12.7982C21.3127 12.3697 21.8939 12.1289 22.5 12.1289ZM26.7188 31.9922H18.9844C18.6114 31.9922 18.2537 31.844 17.99 31.5803C17.7263 31.3166 17.5781 30.9589 17.5781 30.5859C17.5781 30.213 17.7263 29.8553 17.99 29.5916C18.2537 29.3278 18.6114 29.1797 18.9844 29.1797H21.4453V21.4453H20.0391C19.6661 21.4453 19.3084 21.2972 19.0447 21.0334C18.781 20.7697 18.6328 20.412 18.6328 20.0391C18.6328 19.6661 18.781 19.3084 19.0447 19.0447C19.3084 18.781 19.6661 18.6328 20.0391 18.6328H22.8516C23.2245 18.6328 23.5822 18.781 23.8459 19.0447C24.1097 19.3084 24.2578 19.6661 24.2578 20.0391V29.1797H26.7188C27.0917 29.1797 27.4494 29.3278 27.7131 29.5916C27.9768 29.8553 28.125 30.213 28.125 30.5859C28.125 30.9589 27.9768 31.3166 27.7131 31.5803C27.4494 31.844 27.0917 31.9922 26.7188 31.9922Z" fill="#255A94"/>
              </svg>
            </IconDiv>
            <DescriptionDiv 
              dangerouslySetInnerHTML={{
                __html: instruction,
              }} 
            />
          </InstructionDiv>
      }
      <ContentFlexContainer>
        <ActionCardFlexContainer>
          <ActionCard>
            <SignupForm />
          </ActionCard>
        </ActionCardFlexContainer>
      </ContentFlexContainer>
      
    </AuthFlexContainer>
  );
}